<div *ngIf="flag == 'th'; else elsebanner">
    <app-page-header [isCurveGray]="false" header="{{language.menu4}}" *ngFor="let item of banner"
        [ngClass]="(item.no==0)?'carousel-item active':'carousel-item'"
        backgroundPath="{{!isMobile ? item.banner_image : item.banner_image_mobile}}">
    </app-page-header>
</div>
<ng-template #elsebanner>
    <app-page-header [isCurveGray]="false" header="{{language.menu4}}" *ngFor="let item of banner"
        [ngClass]="(item.no==0)?'carousel-item active':'carousel-item'"
        backgroundPath="{{!isMobile ? item.banner_image_en : item.banner_image_mobile}}">
    </app-page-header>
</ng-template>

<section class="content-inner pattern-static">
    <div class="container">
        <section class="section-group -highlight">
            <header>
                <h2 class="topic-title">
                    <span rel="border-circle">
                        <img src="../assets/images/provident/icon-paper-chart@2x.png" width="19">
                    </span>
                    <span class="text"> {{language.providenttitle1}} </span>
                </h2>
                <h3 class="topic-title sub-title mb-3">{{language.providenttitle1detail}}</h3>
            </header>

            <div class="row">
                <div class="col-sm-6 col-md-6 col-lg-3">
                    <section class="group-item">
                        <div class="photo">
                            <img src="../assets/images/provident/hand-shake@2x.png" class="img-fluid" alt="hand-shake">
                        </div>
                        <p>
                            {{language.providenttitle1detailmenu1line1}}
                            <br> {{language.providenttitle1detailmenu1line2}}
                            <br> {{language.providenttitle1detailmenu1line3}}
                        </p>
                    </section>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-3">
                    <section class="group-item">
                        <div class="photo">
                            <img src="../assets/images/provident/money-bag@2x.png" class="img-fluid" alt="money-bag">
                        </div>
                        <p>
                            {{language.providenttitle1detailmenu2line1}}
                            <br> {{language.providenttitle1detailmenu2line2}}
                            <br> {{language.providenttitle1detailmenu2line3}}
                        </p>
                    </section>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-3">
                    <section class="group-item">
                        <div class="photo">
                            <img src="../assets/images/provident/piggy-bank@2x.png" class="img-fluid" alt="piggy-bank">
                        </div>
                        <p>
                            {{language.providenttitle1detailmenu3line1}}
                            <br>{{language.providenttitle1detailmenu3line2}}
                        </p>
                    </section>
                </div>
                <div class="col-sm-6 col-md-6 col-lg-3">
                    <section class="group-item">
                        <div class="photo">
                            <img src="../assets/images/provident/skyline@2x.png" class="img-fluid" alt="skyline">
                        </div>
                        <p>
                            {{language.providenttitle1detailmenu4line1}}
                            <br> {{language.providenttitle1detailmenu4line2}}
                            <br> {{language.providenttitle1detailmenu4line3}}
                        </p>
                    </section>
                </div>
            </div>
        </section>

        <section class="section-group -objective">
            <header>
                <h3 class="topic-title sub-title">{{language.providenttitle1sub1}}</h3>
            </header>
            <div class="info">
                <ol>
                    <li>
                        {{language.providenttitle1sub1line1}}
                    </li>
                    <li>
                        {{language.providenttitle1sub1line2}}
                    </li>
                    <li>
                        {{language.providenttitle1sub1line3}}
                    </li>
                    <li>
                        {{language.providenttitle1sub1line4}}
                    </li>
                </ol>
            </div>

            <div class="info">
                <h3 class="topic-title sub-title">{{language.providenttitle1sub2}}</h3>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <section class="wrapper-section">
                            <h3 class="topic-title sub-title">{{language.providenttitle1sub2l}}</h3>
                            <ol>
                                <li>{{language.providenttitle1sub2lline1}}</li>
                                <li>{{language.providenttitle1sub2lline2}}</li>
                                <li>{{language.providenttitle1sub2lline3}}</li>
                                <li>{{language.providenttitle1sub2lline4}}</li>
                            </ol>
                        </section>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <section class="wrapper-section">
                            <h3 class="topic-title sub-title">{{language.providenttitle1sub2r}}</h3>
                            <ol>
                                <li>{{language.providenttitle1sub2rline1}}</li>
                                <li>{{language.providenttitle1sub2rline2}}</li>
                                <li>{{language.providenttitle1sub2rline3}}</li>
                                <li>{{language.providenttitle1sub2rline4}}</li>
                            </ol>
                        </section>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-group -structure have-border">
            <section>
                <header>
                    <h2 class="topic-title">
                        <span rel="border-circle">
                            <img src="../assets/images/provident/icon-pyramid@2x.png" width="19">
                        </span>
                        <span class="text">{{language.providenttitle2}}</span>
                    </h2>
                </header>

                <section class="info">
                    <div class="photo">
                        <img *ngIf="flag == 'th';else elseinfographic"
                            src="../assets/images/provident/infographic@2x.jpg" class="img-fluid" alt="infographic">
                        <ng-template #elseinfographic>
                            <img src="../assets/images/provident/infographic@2x-Eng.jpg" class="img-fluid"
                                alt="infographic">
                        </ng-template>
                    </div>

                    <h3 class="topic-title sub-title">
                        {{language.providenttitle2detail}}
                    </h3>
                    <ul class="list-unstyled list-bullet-number -notitle">
                        <li>
                            <span class="number">1</span>
                            <div class="intro">
                                <p>
                                    {{language.providenttitle2detailline1}}
                                </p>
                            </div>
                        </li>
                        <li>
                            <span class="number">2</span>
                            <div class="intro">
                                <p>
                                    {{language.providenttitle2detailline2}}
                                </p>
                            </div>
                        </li>
                        <li>
                            <span class="number">3</span>
                            <div class="intro">
                                <p>
                                    {{language.providenttitle2detailline3p1}}
                                </p>
                                <p>
                                    {{language.providenttitle2detailline3p2}}
                                </p>
                            </div>
                        </li>
                        <li>
                            <span class="number">4</span>
                            <div class="intro">
                                <p>
                                    {{language.providenttitle2detailline4}}
                                </p>
                            </div>
                        </li>
                        <li>
                            <span class="number">5</span>
                            <div class="intro">
                                <p>
                                    {{language.providenttitle2detailline5}}
                                    <a href="http://www.sec.or.th/invsup/approve/pvdcom.shtml" target="_blank">
                                        www.sec.or.th/invsup/approve/pvdcom.shtml
                                    </a>
                                </p>
                            </div>
                        </li>
                        <li>
                            <span class="number">6</span>
                            <div class="intro">
                                <p>
                                    {{language.providenttitle2detailline6}}
                                    <a href="http://www.sec.or.th/invsup/approve/audittsh.shtml" target="_blank">
                                        www.sec.or.th/invsup/approve/audittsh.shtml
                                    </a>
                                </p>
                            </div>
                        </li>
                        <li>
                            <span class="number">7</span>
                            <div class="intro">
                                <p>
                                    {{language.providenttitle2detailline7}}
                                    <a href="http://www.sec.or.th/invsup/approve/custodia.shtml" target="_blank">
                                        www.sec.or.th/invsup/approve/custodia.shtml
                                    </a>
                                </p>
                            </div>
                        </li>
                        <li>
                            <span class="number">8</span>
                            <div class="intro">
                                <p>
                                    {{language.providenttitle2detailline8}}
                                </p>
                            </div>
                        </li>
                        <li>
                            <span class="number">9</span>
                            <div class="intro ">
                                <p>
                                    {{language.providenttitle2detailline9}}
                                </p>
                            </div>
                        </li>
                        <li>
                            <span class="number">10</span>
                            <div class="intro">
                                <p>
                                    {{language.providenttitle2detailline10}}
                                </p>
                            </div>
                        </li>
                    </ul>

                    <p class="note">
                        {{language.providenttitle2detaillinelast}}
                    </p>
                </section>

            </section>
        </section>

        <section class="section-group have-border">
            <header>
                <h2 class="topic-title">
                    <span rel="border-circle">
                        <img src="../assets/images/private/medium_@2x.png">
                    </span>
                    <span class="text">{{language.providenttitle3}}</span>
                </h2>
            </header>
            <div class="info mt-0">
                <div class="row">
                    <ul class="list-download list-unstyled" style="display: contents">
                        <li class="col-md-6 col-xl-4" *ngFor="let item of doc_list">
                            <div *ngIf="flag == 'th'; else elsedoc_list">
                                <a href="{{item.filePath}}" target="_blank">

                                    <i class="fas fa-download mr-2 icon-color"></i>

                                    <span>{{item.fileName}}</span>
                                </a>
                            </div>
                            <ng-template #elsedoc_list>
                                <a href="{{item.filePath_en}}" target="_blank">

                                    <i class="fas fa-download mr-2 icon-color"></i>

                                    <span>{{item.fileName_en}}</span>
                                </a>

                            </ng-template>
                        </li>
                    </ul>
                </div>
            </div>
        </section>

        <section class="section-group -portfolio have-border">
            <header>
                <h2 class="topic-title">
                    <span rel="border-circle">
                        <img src="../assets/images/private/icon-risks@2x.png">
                    </span>
                    <span class="text">
                        {{language.providenttitle4}}
                    </span>
                </h2>
                <p class="intro">
                    {{language.providenttitle4detail}}
                </p>
            </header>
            <section class="info mt-0">
                <header>
                    <span rel="border-circle">
                        <img src="../assets/images/private/low_@2x.png">
                    </span>
                    <h3 class="topic-title sub-title">{{language.providenttitle5}}</h3>
                    <p>
                        {{language.providenttitle5detail}}
                    </p>
                </header>

                <div class="photo">
                    <img *ngIf="flag == 'th';else elseconservative" src="../assets/images/graph/conservative@2x.png"
                        class="img-fluid" alt="conservative portfolio" data-rjs="2" data-rjs-processed="true"
                        width="384" height="204">
                    <ng-template #elseconservative>
                        <img src="../assets/images/graph/conservative@2x-Eng.jpg" class="img-fluid"
                            alt="conservative portfolio" data-rjs="2" data-rjs-processed="true" width="384"
                            height="204">
                    </ng-template>
                </div>

                <section class="group">
                    <h3 class="topic-title sub-title">{{language.providenttitle5sub1}}</h3>
                    <p>
                        {{language.providenttitle5sub1detail}}
                    </p>
                </section>

                <section class="group">
                    <h3 class="topic-title sub-title">{{language.providenttitle5sub2}}</h3>
                    <p>{{language.providenttitle5sub2detail}}</p>
                </section>
            </section>

            <section class="info">
                <header>
                    <span rel="border-circle">
                        <img src="../assets/images/private/medium_@2x.png">
                    </span>
                    <h3 class="topic-title sub-title">{{language.providenttitle6}}</h3>
                    <p>
                        {{language.providenttitle6detail}}
                    </p>
                </header>

                <div class="photo">
                    <img *ngIf="flag == 'th';else elsemoderate" src="../assets/images/graph/moderate@2x.png"
                        class="img-fluid" alt="moderate portfolio" data-rjs="2" data-rjs-processed="true" width="384"
                        height="204">
                    <ng-template #elsemoderate>
                        <img src="../assets/images/graph/moderate@2x-Eng.jpg" class="img-fluid" alt="moderate portfolio"
                            data-rjs="2" data-rjs-processed="true" width="384" height="204">
                    </ng-template>
                </div>

                <section class="group">
                    <h3 class="topic-title sub-title">{{language.providenttitle6sub1}}</h3>
                    <p>
                        {{language.providenttitle6sub1detail}}
                    </p>
                </section>

                <section class="group">
                    <h3 class="topic-title sub-title">{{language.providenttitle6sub2}}</h3>
                    <p>{{language.providenttitle6sub2detail}}</p>
                </section>

            </section>

            <section class="info">
                <header>
                    <span rel="border-circle">
                        <img src="../assets/images/private/high_@2x.png">
                    </span>
                    <h3 class="topic-title sub-title">{{language.providenttitle7}}</h3>
                    <p>
                        {{language.providenttitle7detail}}
                    </p>
                </header>

                <div class="photo">
                    <img *ngIf="flag == 'th';else elseaggressive" src="../assets/images/graph/aggressive@2x.png"
                        class="img-fluid" alt="aggressive portfolio" data-rjs="2" data-rjs-processed="true" width="380"
                        height="204">
                    <ng-template #elseaggressive>
                        <img src="../assets/images/graph/aggressive@2x-Eng.jpg" class="img-fluid"
                            alt="aggressive portfolio" data-rjs="2" data-rjs-processed="true" width="380" height="204">
                    </ng-template>
                </div>
                <section class="group">
                    <h3 class="topic-title sub-title">{{language.providenttitle7sub1}}</h3>
                    <p>
                        {{language.providenttitle7sub1detail}}
                    </p>
                </section>

                <section class="group">
                    <h3 class="topic-title sub-title">{{language.providenttitle7sub2}}</h3>
                    <p>{{language.providenttitle7sub2detail}}</p>
                </section>
            </section>
        </section>

        <section class="section-group have-border">
            <header>
                <h2 class="topic-title">
                    <span rel="border-circle">
                        <img src="../assets/images/private/icon-phone_@2x.png" style="width: 21px;">
                    </span>
                    <span class="text">{{language.contaxtitle}}</span>
                </h2>
            </header>
            <div class="info mt-0">
                <p>
                    {{language.contaxaddressline1}}
                    <br> {{language.contaxaddressline2}}
                </p>
            </div>

            <div class="info mt-0">
                <p>
                    {{language.contaxdetail}}
                </p>
                <ul class="list list-inline list-contact">
                    <li>
                        <span rel="border-circle">
                            <img src="../assets/images/private/icon-phone@2x.png">
                        </span>
                        <span>{{language.contaxtel1}}</span>
                    </li>
                    <li>
                        <span rel="border-circle">
                            <img src="../assets/images/private/ic-fax@2x.png">
                        </span>
                        <span>{{language.contaxtel2}}</span>
                    </li>
                    <li>
                        <span rel="border-circle">
                            <img src="../assets/images/private/ic-mail@2x.png">
                        </span>
                        <a href="mailto:pd@one-asset.com">{{language.contaxemail}}</a>
                    </li>
                </ul>
            </div>
        </section>

    </div>
</section>